import React from 'react';
import { motion } from 'framer-motion';

const TypingIndicator = () => {
  return (
    <div className="typing-indicator">
      <span className="typing-text">écrit</span>
      <div className="typing-dots">
        <motion.span
          className="dot"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 0.5, repeat: Infinity, delay: 0 }}
        />
        <motion.span
          className="dot"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 0.5, repeat: Infinity, delay: 0.15 }}
        />
        <motion.span
          className="dot"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 0.5, repeat: Infinity, delay: 0.3 }}
        />
      </div>
    </div>
  );
};

export const TypingBubble = () => {
  return (
    <div className="typing-bubble">
      <div className="typing-dots-container">
        <motion.span
          className="typing-dot"
          animate={{ 
            scale: [1, 1.2, 1],
            opacity: [0.4, 1, 0.4]
          }}
          transition={{ duration: 1, repeat: Infinity, delay: 0 }}
        />
        <motion.span
          className="typing-dot"
          animate={{ 
            scale: [1, 1.2, 1],
            opacity: [0.4, 1, 0.4]
          }}
          transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
        />
        <motion.span
          className="typing-dot"
          animate={{ 
            scale: [1, 1.2, 1],
            opacity: [0.4, 1, 0.4]
          }}
          transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
        />
      </div>
    </div>
  );
};

export default TypingIndicator;
